(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bookingOld', {
            parent: 'app',
            url: '/booking/dentist/:practice',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/booking/booking.html',
                    controller: 'BookingControllerOld',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
